import { Button } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';

const SPARKLES_ICON_SRC =
  'https://static.parastorage.com/services/kb-client-nextjs/dist/public/images/search-results/sparkles.svg';

const sparklesPrefix = (
  <img src={SPARKLES_ICON_SRC} width={24} height={24} alt="" />
);

export type DiveDeeperChatButtonProps = {
  onClick: () => void;
  href?: string;
  dataHook?: string;
  className?: string;
};

export const DiveDeeperChatButton = ({
  onClick,
  href,
  dataHook,
  className,
}: DiveDeeperChatButtonProps) => {
  const { t } = useTranslation();
  const label = t('search-results.generated-answer.contact-button');
  const sharedProps = {
    skin: 'ai' as const,
    onClick,
    prefixIcon: sparklesPrefix,
    className,
    dataHook,
    children: label,
  };

  if (href) {
    return <Button as="a" href={href} target="_blank" {...sharedProps} />;
  }

  return <Button {...sharedProps} />;
};
